import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  FiUsers,
  FiHome,
  FiAward,
  FiTarget,
  FiEye,
  FiCheckCircle,
} from "react-icons/fi";
import { FaHandshake } from "react-icons/fa";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import ContactStrip from "./ContactStrip";
import "./FooterPages.css";

const AboutUs = () => {
  return (
    <div className="mgh-info-page-wrapper">
      <Helmet>
        <title>About Us | My Golden Homes</title>
        <meta
          name="description"
          content="Learn about My Golden Homes, India's trusted real estate platform connecting buyers, sellers, and tenants since 2005."
        />
      </Helmet>

      {/* Unchanged Header */}
      <Header />

      {/* Hero Banner */}
      <section className="mgh-info-hero">
        <div className="mgh-info-hero-inner">
          <div className="mgh-info-hero-left">
            <div className="mgh-info-breadcrumb">
              <Link to="/">Home</Link>
              <span>&gt;</span>
              <span>About Us</span>
            </div>
            <h1 className="mgh-info-hero-title">
              About <span>My Golden Homes</span>
            </h1>
            <p className="mgh-info-hero-subtitle">
              India&apos;s trusted real estate platform, connecting buyers, sellers, tenants and property professionals since 2005.
            </p>

            <div className="mgh-hero-pills-row">
              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiUsers />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>2M+</strong>
                  <span>Happy Users</span>
                </div>
              </div>

              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiHome />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>500K+</strong>
                  <span>Properties Listed</span>
                </div>
              </div>

              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FaHandshake />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>20+</strong>
                  <span>Years of Trust</span>
                </div>
              </div>

              <div className="mgh-hero-pill">
                <div className="mgh-hero-pill-icon">
                  <FiAward />
                </div>
                <div className="mgh-hero-pill-text">
                  <strong>15+</strong>
                  <span>Industry Awards</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mgh-info-hero-art">
            <img
              src="/assets/images/villa_header_banner.jpg"
              alt="My Golden Homes Architecture"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/why_choose_villa.jpg";
              }}
            />
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <div className="mgh-info-container">
        {/* Story & Mission/Vision Grid */}
        <div className="mgh-about-story-grid">
          <div className="mgh-about-story-card">
            <span className="mgh-tag-badge">OUR STORY —</span>
            <h2 className="mgh-about-story-title">
              Launched in 2005, Mygoldenhomes.com
            </h2>
            <p className="mgh-info-text">
              India&apos;s leading property portal deals with every aspect of consumers&apos; needs in the real estate industry. It is an online forum where buyers, sellers and brokers/agents exchange verified property details quickly, effectively and inexpensively.
            </p>
            <p className="mgh-info-text">
              At Mygoldenhomes.com, you can advertise a property, search for a home, browse through verified developments, build custom property microsites, and stay informed with transparent pricing and real estate trends.
            </p>

            <div className="mgh-about-story-img-wrap">
              <img
                src="/assets/images/why_choose_villa.jpg"
                alt="Building Better Tomorrows"
                className="mgh-about-story-img"
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "12px",
                  left: "12px",
                  background: "rgba(15, 23, 42, 0.85)",
                  color: "#ffffff",
                  padding: "5px 12px",
                  borderRadius: "6px",
                  fontSize: "11.5px",
                  fontWeight: "700",
                }}
              >
                Building Better Tomorrows
              </div>
            </div>
          </div>

          <div>
            <div className="mgh-mv-card">
              <div className="mgh-mv-icon">
                <FiTarget />
              </div>
              <div className="mgh-mv-info">
                <h4>Our Mission</h4>
                <p>
                  To make property search easier, quicker and smarter for everyone with verified listings and complete pricing clarity.
                </p>
              </div>
            </div>

            <div className="mgh-mv-card" style={{ marginTop: "16px" }}>
              <div className="mgh-mv-icon" style={{ background: "#ecfdf5", color: "#059669" }}>
                <FiEye />
              </div>
              <div className="mgh-mv-info">
                <h4>Our Vision</h4>
                <p>
                  To be the most trusted, innovative and customer-centric real estate technology platform across India.
                </p>
              </div>
            </div>

            <div className="mgh-info-callout" style={{ marginTop: "16px" }}>
              <div className="mgh-callout-icon">
                <FiCheckCircle />
              </div>
              <div className="mgh-callout-text">
                <h4>Verified Listings Guarantee</h4>
                <p>Every home, plot, and commercial space goes through rigorous screening before publication.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Awards & Recognition Section */}
        <div className="mgh-awards-section">
          <div className="mgh-awards-header">
            <div className="mgh-awards-trophy-icon">
              <FiAward />
            </div>
            <div>
              <h3>Awards &amp; Recognition</h3>
              <p>Our commitment to excellence has been recognized by leading industry platforms.</p>
            </div>
          </div>

          <div className="mgh-awards-grid">
            <div className="mgh-award-card">
              <span className="mgh-award-year">2019</span>
              <h5 className="mgh-award-title">PropTech Mobile App of the Year</h5>
              <p className="mgh-award-desc">Recognized for premier mobile user experience.</p>
            </div>

            <div className="mgh-award-card">
              <span className="mgh-award-year" style={{ background: "#fef3c7", color: "#d97706" }}>2018</span>
              <h5 className="mgh-award-title">Personalized User Journey</h5>
              <p className="mgh-award-desc">Awarded for customized home seeker search intelligence.</p>
            </div>

            <div className="mgh-award-card">
              <span className="mgh-award-year">2015</span>
              <h5 className="mgh-award-title">Best Mobile Apps Award</h5>
              <p className="mgh-award-desc">Honored for innovative property discovery workflows.</p>
            </div>

            <div className="mgh-award-card">
              <span className="mgh-award-year" style={{ background: "#f3e8ff", color: "#7e22ce" }}>2012</span>
              <h5 className="mgh-award-title">CMO ASIA Awards</h5>
              <p className="mgh-award-desc">Awarded Most Admired Real Estate Website of the Year.</p>
            </div>

            <div className="mgh-award-card">
              <span className="mgh-award-year" style={{ background: "#dcfce7", color: "#15803d" }}>2012</span>
              <h5 className="mgh-award-title">BCI Awards</h5>
              <p className="mgh-award-desc">Recognized as the Best Real Estate Portal.</p>
            </div>

            <div className="mgh-award-card">
              <span className="mgh-award-year" style={{ background: "#ffe4e6", color: "#be123c" }}>2012</span>
              <h5 className="mgh-award-title">Accommodation Times</h5>
              <p className="mgh-award-desc">Announced Best Online Realty Portal.</p>
            </div>
          </div>
        </div>

        {/* Reusable Contact Strip */}
        <ContactStrip />
      </div>

      {/* Unchanged Footer */}
      <Footer />
    </div>
  );
};

export default AboutUs;